import { render, staticRenderFns } from "./CustomBaseEntityFilter.vue?vue&type=template&id=cffe9656&scoped=true&"
import script from "./CustomBaseEntityFilter.vue?vue&type=script&lang=js&"
export * from "./CustomBaseEntityFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffe9656",
  null
  
)

export default component.exports